import SettingsContent from '../Wrapper';
import { frontendURL } from '../../../../helper/URLHelper';
import { ensureOpportunityPipelinesManagementAllowed } from '../../../../helper/routeHelpers';
import OpportunityPipelinesIndex from './Index';
import CreateFlowWrapper from './create/Index';
import CreatePipeline from './create/CreatePipeline';
import AddUsers from './create/AddUsers';
import AddInboxes from './create/AddInboxes';
import ManageStages from './create/ManageStages';
import ManageLossReasons from './create/ManageLossReasons';
import FinishSetup from './create/FinishSetup';
import NegotiationForm from './negotiationForm/Index';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/opportunity-pipelines'),
      component: SettingsContent,
      beforeEnter: ensureOpportunityPipelinesManagementAllowed,
      props: params => {
        const showBackButton =
          params.name !== 'settings_opportunity_pipelines_list';
        const isNegotiationForm =
          params.name === 'settings_opportunity_pipelines_negotiation_form';
        const backUrl = isNegotiationForm
          ? { name: 'settings_opportunity_pipelines_list' }
          : '';

        return {
          headerTitle: isNegotiationForm
            ? 'OPPORTUNITY_PIPELINES.NEGOTIATION_FORM.HEADER'
            : 'OPPORTUNITY_PIPELINES.HEADER',
          headerButtonText: 'OPPORTUNITY_PIPELINES.NEW_PIPELINE',
          icon: isNegotiationForm ? 'document' : 'briefcase',
          newButtonRoutes: ['settings_opportunity_pipelines_list'],
          showBackButton,
          backUrl,
          keepAlive: false,
        };
      },
      children: [
        {
          path: '',
          name: 'settings_opportunity_pipelines_wrapper',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'settings_opportunity_pipelines_list',
          component: OpportunityPipelinesIndex,
          roles: [
            'administrator',
            'agent',
            'seller',
            'supervisor',
            'team_supervisor',
            'analyzer',
            'assistant',
            'embed',
          ],
        },
        {
          path: ':pipelineId/negotiation-form',
          name: 'settings_opportunity_pipelines_negotiation_form',
          component: NegotiationForm,
          roles: ['administrator'],
        },
        {
          path: 'new',
          component: CreateFlowWrapper,
          children: [
            {
              path: '',
              name: 'settings_opportunity_pipelines_new',
              component: CreatePipeline,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: ':pipelineId/edit',
              name: 'settings_opportunity_pipelines_edit',
              component: CreatePipeline,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: 'users',
              name: 'settings_opportunity_pipelines_new_users',
              component: AddUsers,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: 'inboxes',
              name: 'settings_opportunity_pipelines_new_inboxes',
              component: AddInboxes,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: 'stages',
              name: 'settings_opportunity_pipelines_new_stages',
              component: ManageStages,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: 'loss-reasons',
              name: 'settings_opportunity_pipelines_new_loss_reasons',
              component: ManageLossReasons,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: 'finish',
              name: 'settings_opportunity_pipelines_new_finish',
              component: FinishSetup,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: ':pipelineId/users',
              name: 'settings_opportunity_pipelines_users',
              component: AddUsers,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: ':pipelineId/inboxes',
              name: 'settings_opportunity_pipelines_inboxes',
              component: AddInboxes,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: ':pipelineId/stages',
              name: 'settings_opportunity_pipelines_stages',
              component: ManageStages,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: ':pipelineId/loss-reasons',
              name: 'settings_opportunity_pipelines_loss_reasons',
              component: ManageLossReasons,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
            {
              path: ':pipelineId/finish',
              name: 'settings_opportunity_pipelines_finish',
              component: FinishSetup,
              roles: [
                'administrator',
                'agent',
                'seller',
                'supervisor',
                'team_supervisor',
                'analyzer',
                'assistant',
                'embed',
              ],
            },
          ],
        },
      ],
    },
  ],
};
